<template>
    <b-row class="row" :class="{ selected }" @click="doClick">
        <b-col><font-awesome-icon fixed-width :icon="entryIcon" class="mr-2"/>{{entry.cn}}</b-col>
        <b-col>{{entry.mail}}</b-col>
    </b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'addressBookEntry',
  components: { FontAwesomeIcon },
  props: {
    entry: Object,
    scopes: Array,
    selected: Boolean
  },
  methods: {
    scrollIntoView() {
      this.$el.scrollIntoView({ behaviour: 'smooth', block: 'nearest' });
    },
    doClick() {
      this.$emit('click');
    }
  },
  computed: {
    scope() {
      return this.scopes.find(s => s.id === this.entry._parentid);
    },
    entryIcon() {
      if (this.scope) {
        if (this.scope.standard) {
          if (this.scope.name === 'users') {
            return 'user';
          } else if (this.scope.name === 'lists') {
            return 'users';
          } else if ((this.scope.name === 'personal') || (this.scope.name === 'external') ||
            (this.scope.name === 'global')) {
            return ['far', 'globe'];
          }
        } else {
          return ['far', 'globe'];
        }
      }
      return 'question-circle';
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .row {
        &:hover {
            background-color: $address-list-hover-bg;
        }
        &.selected {
            background-color: $address-list-select-bg;
            color: $address-list-select-fg;
            &:hover {
                background-color: $address-list-select-hover-bg;
            }
        }

    }
</style>
